var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88458 0.615385C7.88458 0.275517 8.1601 0 8.49997 0C8.83983 0 9.11535 0.275517 9.11535 0.615385V3.69231C9.11535 4.03218 8.83983 4.30769 8.49997 4.30769C8.1601 4.30769 7.88458 4.03218 7.88458 3.69231V0.615385Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88458 12.3077C7.88458 11.9678 8.1601 11.6923 8.49997 11.6923C8.83983 11.6923 9.11535 11.9678 9.11535 12.3077V15.3846C9.11535 15.7245 8.83983 16 8.49997 16C8.1601 16 7.88458 15.7245 7.88458 15.3846V12.3077Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8846 7.38462C16.2245 7.38462 16.5 7.66014 16.5 8.00001C16.5 8.33987 16.2245 8.61539 15.8846 8.61539H12.8077C12.4678 8.61539 12.1923 8.33987 12.1923 8.00001C12.1923 7.66014 12.4678 7.38462 12.8077 7.38462L15.8846 7.38462Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19229 7.38462C4.53216 7.38462 4.80768 7.66014 4.80768 8.00001C4.80768 8.33987 4.53216 8.61539 4.19229 8.61539H1.11537C0.775503 8.61539 0.499986 8.33987 0.499986 8.00001C0.499986 7.66014 0.775503 7.38462 1.11537 7.38462L4.19229 7.38462Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5876 3.77476C14.8819 3.60482 15.2583 3.70567 15.4282 4C15.5982 4.29434 15.4973 4.6707 15.203 4.84063L12.5383 6.3791C12.244 6.54903 11.8676 6.44818 11.6977 6.15385C11.5277 5.85951 11.6286 5.48315 11.9229 5.31322L14.5876 3.77476Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46175 9.6209C4.75609 9.45097 5.13245 9.55181 5.30238 9.84615C5.47232 10.1405 5.37147 10.5168 5.07714 10.6868L2.41244 12.2252C2.11811 12.3952 1.74175 12.2943 1.57181 12C1.40188 11.7057 1.50272 11.3293 1.79706 11.1594L4.46175 9.6209Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6593 1.29706C11.8293 1.00273 12.2056 0.90188 12.5 1.07181C12.7943 1.24175 12.8952 1.61811 12.7252 1.91245L11.1868 4.57714C11.0168 4.87147 10.6405 4.97232 10.3461 4.80239C10.0518 4.63245 9.95095 4.25609 10.1209 3.96175L11.6593 1.29706Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81322 11.4229C5.98315 11.1286 6.35952 11.0277 6.65385 11.1976C6.94818 11.3676 7.04903 11.7439 6.8791 12.0383L5.34063 14.703C5.1707 14.9973 4.79434 15.0982 4.5 14.9282C4.20567 14.7583 4.10482 14.3819 4.27476 14.0876L5.81322 11.4229Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7253 14.0875C12.8952 14.3819 12.7944 14.7582 12.5 14.9282C12.2057 15.0981 11.8293 14.9973 11.6594 14.7029L10.1209 12.0382C9.95099 11.7439 10.0518 11.3675 10.3462 11.1976C10.6405 11.0277 11.0169 11.1285 11.1868 11.4229L12.7253 14.0875Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87908 3.96173C7.04901 4.25606 6.94816 4.63243 6.65383 4.80236C6.35949 4.97229 5.98313 4.87145 5.8132 4.57711L4.27474 1.91242C4.1048 1.61809 4.20565 1.24172 4.49998 1.07179C4.79432 0.901855 5.17068 1.0027 5.34061 1.29704L6.87908 3.96173Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.203 11.1594C15.4973 11.3293 15.5981 11.7057 15.4282 12C15.2583 12.2943 14.8819 12.3952 14.5876 12.2252L11.9229 10.6868C11.6286 10.5169 11.5277 10.1405 11.6976 9.84616C11.8676 9.55182 12.2439 9.45098 12.5383 9.62091L15.203 11.1594Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07711 5.31322C5.37144 5.48315 5.47229 5.85952 5.30235 6.15385C5.13242 6.44818 4.75606 6.54903 4.46172 6.3791L1.79703 4.84063C1.5027 4.6707 1.40185 4.29434 1.57178 4C1.74172 3.70567 2.11808 3.60482 2.41241 3.77476L5.07711 5.31322Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoading);
export default __webpack_public_path__ + "static/media/icon-loading.0a14231157d32e47b9de9b15be9c62c5.svg";
export { ForwardRef as ReactComponent };